import React from 'react';
import { DropdownItem } from 'reactstrap';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { useHeaderContext } from '@oceanjs/ui-bootstrap-header';


export interface HeaderDropdwonItemProps {
  id: string;
  icon: IconDefinition;
  messageId?: string | null;
  onClick: Function; 
}

export const DownloadDropdownItem: React.FC<HeaderDropdwonItemProps> = (props) => {
  const { 
    id,
    icon,
    messageId = null,
    onClick
  } = props;

  const { closeNavbar } = useHeaderContext();
  return (
    <DropdownItem
      id={id}
      onClick={(e: React.MouseEvent) => {
        closeNavbar();
        onClick(e);
      }}
    >
      <FontAwesomeIcon fixedWidth icon={icon} className="mr-1" />
      <FormattedMessage id={messageId || id} />
    </DropdownItem>
  );

}
